module.exports = __webpack_public_path__ + "static/02-764d7a50d6e11d2b0916241da9875502.jpg";